import React from 'react';
import CourseCard from './CourseCard';
import MyLoader from './Loader';

const CourseSection = ({ title, description, courses, colorClass, loading }) => (
  <section className={`course-section ${colorClass}`}>
    <h2 className="section-title-formas">{title}</h2>
    <div className="section-divider" />
    <p
      className="section-description"
      dangerouslySetInnerHTML={{ __html: description }}
    ></p>
    <div className="row">
      {loading ? (
        MyLoader()
      ) : (
        courses.map((course, index) => (
          <CourseCard key={index} course={course} />
        ))
      )}

    </div>
  </section>
);

export default CourseSection;